import { Edit } from '@mui/icons-material';
import { Avatar, Chip, type ChipProps } from '@mui/material';

import React from 'react';
import { ReportImage } from '~/components/ReportImage';
import { Searches } from '~/types/searches';

export interface ReportChipProps extends Omit<ChipProps, 'onDelete'> {
  item: Searches.ISearchItem;
  onDelete?: (option: Searches.ISearchItem) => void;
  onCodeEdit?: (option: Searches.ISearchItem) => void;
  avatarProps?: React.ComponentPropsWithoutRef<typeof Avatar>;
}

interface ReportChipAvatarProps
  extends React.ComponentPropsWithoutRef<typeof Avatar> {
  item: Searches.ISearchItem;
  hovering: boolean;
  onCodeEdit?: (option: Searches.ISearchItem) => void;
}
const ReportChipAvatar = ({
  item,
  hovering,
  onCodeEdit,
  ...avatarProps
}: ReportChipAvatarProps) => {
  const { sx, ...rest } = avatarProps;
  return (
    <>
      {item.type === 'code' && hovering && (
        <Avatar
          variant="circular"
          sx={{ cursor: 'pointer', background: 'white', ...sx }}
          {...rest}
          onClick={() => {
            onCodeEdit?.(item);
          }}>
          <Edit />
        </Avatar>
      )}
      {(!hovering || item.type === 'report') && (
        <Avatar
          variant="circular"
          sx={{ cursor: 'pointer', background: 'white', ...sx }}
          {...rest}>
          <ReportImage uuid={item.type === 'report' ? item.value : '0'} />
        </Avatar>
      )}
    </>
  );
};

export default function ReportChip({
  item,
  onDelete,
  onCodeEdit,
  avatarProps,
  ...chipProps
}: ReportChipProps) {
  const { ...rest } = chipProps;

  const [hovered, setHovered] = React.useState(false);

  const handleMouseEnter = () => {
    setHovered(true);
  };
  const handleMouseLeave = () => {
    setHovered(false);
  };
  return (
    <Chip
      variant={'outlined'}
      className={'report-chip'}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      label={item.type === 'code' ? <code>{item.value}</code> : item.name}
      key={`${item.type}-${item.value}`}
      onDelete={onDelete}
      avatar={
        <ReportChipAvatar
          item={item}
          hovering={hovered}
          onCodeEdit={onCodeEdit}
          {...avatarProps}
        />
      }
      {...rest}
    />
  );
}
